export default function modelRSTS({
    modelSS,
    CC,
    poplatekPU,
    sazbaPU,
    splatkaPU,
    vedeniUctuSS,
    vedeniUctuPU,
    vyplata,
    sazbaSU,
    splatkaSU
}) {
    let table = []

    // prvni radek
    let A = 1
    let D = 1
    let E = CC
    let F = CC * poplatekPU
    let G = F
    let J = sazbaPU

    let K = E * J / 12
    let L = 0
    if (modelSS[0].AB > 0) {
        L = modelSS[0].AB
    } else {
        if (modelSS[0].R !== null) {
            L = splatkaPU
        } else {
            L = splatkaSU
        }
    }
    let M = 0
    if (G > 0) {
        if (G >= L) {
            M = L
        } else {
            M = L - G
        }
    }

    let N = Math.min(K, L - M)
    let O = L - (M + N)
    let H = K - N
    let I = E + G + H

    table.push({ A, D, E, F, G, H, I, J, K, L, M, N, O })

    // dalsi radky
    let i = 0
    let p = 0

    while (E > 0) {
        i++
        p = i - 1

        A++
        D++

        E = 0
        if (i >= modelSS.length && (table[p].E <= table[p].L || table[p].E === 0)) {
            E = 0
        } else {
            if (i < modelSS.length - 1 && modelSS[i + 1].R === null) {
                E = table[p].E - vyplata
            } else {
                E = table[p].E - table[p].O
            }
        }

        F = 0
        if (A % 12 === 0) {
            F = vedeniUctuPU
        } else {
            if (A % 3 === 0) {
                F = vedeniUctuPU
            }
        }

        G = 0
        if (E !== null) {
            G = table[p].G - table[p].M + F
        }

        J = 0
        if (E === 0) {
            J = 0
        } else {
            if (i < modelSS.length && modelSS[i] !== null && modelSS[i].R !== null) {
                J = sazbaPU
            } else {
                J = sazbaSU
            }
        }

        K = E * J / 12

        L = 0
        if (i < modelSS.length && modelSS[i].AB > 0) {
            L = modelSS[i].AB
        } else {
            if (i < modelSS.length && modelSS[i].R !== null) {
                L = splatkaPU
            } else {
                if (E === 0) {
                    L = 0
                } else {
                    L = splatkaSU
                }
            }
        }

        M = 0
        if (i < modelSS.length - 1 && modelSS[i + 1].R === null) {
            M = 0
        } else {
            if (G > 0) {
                M = G >= L ? L : G
            } else {
                M = 0
            }
        }

        N = 0
        if (i < modelSS.length - 1 && modelSS[i + 1].R === null) {
            N = 0
        } else {
            N = Math.min(L - M, K + table[p].H)
        }

        H = Math.max(table[p].H + K - N, 0)

        I = 0
        if (i >= modelSS.length && (table[p].I <= table[p].L || table[p].I === 0)) {
            I = 0
        } else {
            I = E + G + H
        }

        O = 0
        if (i < modelSS.length - 1 && modelSS[i + 1].R === null) {
            O = 0
        } else {
            O = L - (M + N)
        }

        table.push({ A, D, E, F, G, H, I, J, K, L, M, N, O })
    }

    // posledni radek
    // F = 0
    // A++
    // if (A % 12 === 0) {
    //     F = vedeniUctuPU
    // } else {
    //     if (A % 3 === 0) {
    //         F = vedeniUctuSS
    //     }
    // }

    // table.push({
    //     A: A,
    //     D: 0,
    //     E: 0,
    //     F: F,
    //     G: 0,
    //     H: 0,
    //     I: 0,
    //     J: 0,
    //     K: 0,
    //     L: 0,
    //     M: 0,
    //     N: 0,
    //     O: 0
    // })


    return table
}